import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../themes/index';

const FieldErrorWrapper = styled.div`
  color: ${colors.negativeColor};
  height: 25px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function FieldError(props: any) {
  const {
    form: { errors, touched },
    field: { name }
  } = props;
  return <FieldErrorWrapper>{touched[name] && errors[name] && errors[name]}</FieldErrorWrapper>;
}
